import { FC } from 'react';
import type { BannerStripData } from '@adapters/prismic/utils/mapBannerStripData';
import PrismicBannerStrip from './PrismicBannerStrip';
import styles from './BannerStripSlice.module.scss';

const BannerStripSlice: FC<{ data: BannerStripData }> = ({ data }) => (
  <div className={styles.bannerStripSlice}>
    <PrismicBannerStrip data={data} interactionLocation="body" />
  </div>
);

export default BannerStripSlice;
